<script setup>
import {OhVueIcon} from "oh-vue-icons";
import { useCurrencyInput } from 'vue-currency-input'

defineEmits(['updated-input']);

const props = defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  options: {
    type: Object,
    default: () => {
      return {};
    }
  }
});

const { inputRef } = useCurrencyInput(props.options);
</script>
<template>
  <div class="relative">
    <div
        v-if="modelValue"
        class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
      <OhVueIcon name="hi-check"  class="text-slate-400"/>
    </div>
    <input
        ref="inputRef"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        type="text"
        @blur="$emit('updated-input')"
    />
  </div>
</template>

